module.exports = __webpack_public_path__ + "img/export.4d99aace.svg";